<template>
  <header class="service-header p-4">
    <h1 class="fall-down">
      Missions de livraison pour livreurs indépendants sur {{ town.town }}
    </h1>
    <p class="image-fade-in">
      Trouvez des <strong>missions de livraison</strong> régulières en tant que
      <strong>livreur indépendant</strong> à {{ town.town }} grâce à
      <span class="brand-name">Livratos</span>, la plateforme dédiée au
      <strong
        >transport de matériel sur chantier à {{ town.town }} et ses
        alentours</strong
      >.
    </p>
  </header>
  <TriangleSeparator />
  <main class="container-fluid">
    <div class="container pt-5 my-5">
      <!--Section: Content-->
      <section class="text-center">
        <p
          class="font-weight-normal text-center text-uppercase font-small mb-4 fall-down"
        >
          {{ town.town }}
        </p>
        <!-- Section heading -->
        <h2 class="font-weight-bold mb-4 pb-2 fall-down">
          Trouver des missions de livraison BTP à {{ town.town }}
        </h2>
        <hr class="w-header" />
        <div class="container mb-5">
          <p class="text-center mx-auto mb-5">
            <span class="brand-name">Livratos</span> est une plateforme pensée
            pour les <strong>livreurs indépendants</strong> qui veulent trouver
            facilement des <strong>missions de livraison</strong> de matériaux
            BTP sur {{ town.town }} et sa région. En quelques clics, vous
            acceptez une
            <strong
              >mission de livraison sur un chantier à {{ town.town }}</strong
            >
            ou aux alentours, vous chargez la marchandise chez le fournisseur et
            vous <strong>livrez</strong> directement sur le
            <strong>chantier</strong>. Vous remplissez votre planning avec des
            <strong>missions de livraison</strong> locales, sans avoir à
            chercher des clients un par un.
          </p>
        </div>
        <!-- Section description -->
        <p class="lead mx-auto mt-4 mt-lg-5 pt-2 pt-lg-5 my-5">
          Quelques-uns des avantages qu’offre
          <span class="brand-name">Livratos</span> aux
          <strong>livreurs indépendants</strong> sur {{ town.town }}.
        </p>

        <section class="features">
          <div class="container">
            <div class="container">
              <div class="box">
                <span></span>
                <div class="content">
                  <h2>Livraison régulières</h2>
                  <p>
                    Recevez des <strong>missions de livraison</strong> sans
                    avoir à prospecter : avec Livratos, les fournisseurs BTP
                    publient leurs besoins et vous, en tant que
                    <strong>livreur</strong> ou
                    <strong>chauffeur-livreur indépendant</strong>, choisissez
                    les missions qui correspondent à votre planning.
                  </p>
                </div>
              </div>
              <div class="box">
                <span></span>
                <div class="content">
                  <h2>Livraisons sur chantier à {{ town.town }}</h2>
                  <p>
                    En tant que <strong>livreur</strong>, vous intervenez sur
                    des <strong>chantiers dans {{ town.town }}</strong> et ses
                    alentours : vous chargez chez le fournisseur, puis réalisez
                    la <strong>livraison</strong> directement sur le
                    <strong>chantier</strong> au créneau demandé, pour des
                    missions concrètes et bien payées.
                  </p>
                </div>
              </div>
              <div class="box">
                <span></span>
                <div class="content">
                  <h2>Suivi des missions</h2>
                  <p>
                    Suivez chaque <strong>mission de livraison</strong> depuis
                    l’acceptation jusqu’à la <strong>livraison</strong> finale.
                    Vous savez exactement où vous devez aller, à quelle heure,
                    et vous gardez un historique clair de vos livraisons et
                    revenus en tant que <strong>livreur indépendant</strong>.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
        <!--First row-->
      </section>
    </div>

    <div class="container pt-5 my-5">
      <!--Section: Content-->
      <section class="">
        <!-- Section heading -->

        <!-- Grid row -->
        <div class="container mb-5">
          <h2 class="text-center font-weight-bold mb-4">
            Des missions de livraison BTP sur {{ town.town
            }}<span class="span-ml"> :</span>
          </h2>
          <p class="text-center mx-au">
            Avec <span class="brand-name">Livratos</span>, vous accédez à des
            <strong>missions de livraison BTP</strong> à
            {{ town.town }} proposées par des fournisseurs de matériaux. Vous
            récupérez la marchandise au dépôt et la
            <strong>livrez</strong> directement sur le
            <strong>chantier</strong> : sacs de ciment, palettes, plaques, bois,
            quincaillerie… En tant que <strong>livreur indépendant</strong>,
            vous remplissez vos journées avec des courses claires, géolocalisées
            et concentrées autour de {{ town.town }}.
          </p>
        </div>
        <div class="block-row pt-lg-5">
          <!-- Grid column -->
          <div class="block-text col-lg-5 slide-left">
            <!-- Featured image -->

            <!-- Section description -->
            <TitleColor
              title="Comment fonctionnent les missions de livraison avec Livratos ?"
              titleColor="#52c234"
            />
            <p class="text-left mx-auto w-responsive">
              La plateforme <span class="brand-name">Livratos</span> met en
              relation des fournisseurs BTP et des
              <strong>livreurs indépendants</strong> sur {{ town.town }}. Les
              professionnels publient leurs
              <strong>missions de livraison</strong> (adresse de retrait,
              <strong>chantier</strong> de destination, créneau horaire, type de
              matériel à transporter), et vous, en tant que
              <strong>livreur</strong>, choisissez les courses qui vous
              intéressent. Une fois la mission acceptée, vous vous rendez au
              dépôt, chargez la marchandise, puis réalisez la
              <strong>livraison sur chantier</strong> directement auprès du
              client. <br />
              En utilisant <span class="brand-name">Livratos</span>, vous
              centralisez vos <strong>missions de livraison</strong>, évitez les
              temps morts, optimisez vos trajets autour de {{ town.town }} et
              développez votre activité de
              <strong>chauffeur-livreur indépendant</strong> sans passer des
              heures à chercher de nouveaux clients.
            </p>

            <ArrowBtn
              href="/about"
              whiteCircleBackground="#52c234"
              circleBoxShadow="0 0 2px 2px #52c234"
            />
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-12 col-lg-5 img-double slide-right">
            <img
              src="@/assets/pictures/vehicule-mockup.webp"
              alt="véhicule de livraison BTP en mission sur un chantier"
              class="img-fluid"
            />
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </section>
      <!--Section: Content-->
    </div>

    <!--Section: Content-->
    <section class="container my-5 pb-5">
      <!-- Grid row -->
      <div class="block-row reverse">
        <!-- Grid column -->
        <div class="block-text slide-right col-lg-5">
          <!-- Category -->
          <!-- Post title -->
          <TitleColor
            title="Pourquoi les missions de livraison BTP sont intéressantes pour les livreurs ?"
            titleColor="#52c234"
            bgColor="#52c234"
          />
          <!-- Excerpt -->
          <p>
            Les <strong>missions de livraison sur chantier</strong> permettent
            aux <strong>livreurs indépendants</strong> de {{ town.town }} de
            travailler avec des clients professionnels réguliers et de remplir
            leurs journées avec des trajets courts et organisés. Avec
            <span class="brand-name">Livratos</span>, chaque
            <strong>mission de livraison</strong> est clairement définie :
            adresse de retrait, <strong>chantier</strong> de destination,
            horaires, matériel. En tant que
            <strong>chauffeur-livreur indépendant</strong>, vous gagnez en
            stabilité, tout en gardant la liberté de choisir vos courses et vos
            horaires.
            <br />
            Cette façon de travailler vous évite les longues périodes sans
            activité, limite les kilomètres inutiles et vous aide à construire
            une base de clients professionnels autour de {{ town.town }} qui ont
            besoin de <strong>livraison</strong> toute l’année.
          </p>

          <ArrowBtn
            href="/about"
            whiteCircleBackground="#52c234"
            circleBoxShadow="0 0 2px 2px #52c234"
          />
        </div>
        <!-- Grid column -->
        <!-- Grid column -->
        <div class="col-lg-6">
          <!-- Featured image -->
          <div class="view overlay rounded z-depth-2 mb-lg-0 slide-left">
            <img
              src="@/assets/pictures/chargement-mockup.webp"
              alt="livreur chargeant des matériaux dans un camion pour une mission de livraison"
              class="img-fluid"
            />
          </div>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
    </section>
    <!--Section: Content-->
    <ContactUsAction />
    <!--DEVWEB-->
    <div class="container pt-5 my-5">
      <!--Section: Content-->
      <section class="">
        <!-- Section heading -->

        <!-- Grid row -->
        <div class="container mb-5">
          <h2 id="developpement-web" class="text-center font-weight-bold mb-4">
            {{ town.town }}<span class="span-ml"> :</span> Opportunités de
            missions de livraison BTP
          </h2>
          <p class="text-center mx-auto mb-5">
            Avec <span class="brand-name">Livratos</span>, les
            <strong>livreurs</strong> et
            <strong>chauffeurs-livreurs indépendants</strong> de
            {{ town.town }} accèdent à des
            <strong>missions de livraison</strong> variées pour les entreprises
            du <strong>BTP</strong>. Vous intervenez sur différents
            <strong>chantiers</strong>, transportez des matériaux essentiels et
            développez une activité régulière et professionnelle autour de
            {{ town.town }}.
          </p>
        </div>
        <div class="block-row pt-lg-3">
          <!-- Grid column -->
          <div class="block-text col-lg-5 slide-left">
            <!-- Featured image -->

            <!-- Section description -->
            <TitleColor
              title="Comprendre les enjeux des missions de livraison sur chantier"
              titleColor="#52c234"
            />
            <p class="text-left mx-auto w-responsive">
              Sur un <strong>chantier</strong>, les retards de
              <strong>livraison</strong> ou les oublis de matériel ont un impact
              direct sur l’organisation et les délais. En tant que
              <strong>livreur indépendant</strong> à {{ town.town }}, vous jouez
              un rôle stratégique : vos
              <strong>missions de livraison</strong> permettent aux équipes sur
              place de continuer à avancer sans interruption. En rejoignant
              <span class="brand-name">Livratos</span>, vous travaillez avec des
              <strong>fournisseurs BTP</strong> locaux qui ont besoin de
              <strong>livreurs</strong> fiables pour acheminer leurs matériaux
              au bon moment et au bon endroit. Vous devenez un maillon essentiel
              de la chaîne logistique, tout en développant une activité de
              <strong>chauffeur-livreur indépendant</strong> stable autour de
              {{ town.town }}.
            </p>

            <ArrowBtn
              href="/about"
              whiteCircleBackground="#52c234"
              circleBoxShadow="0 0 2px 2px #52c234"
            />
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-12 col-lg-5 img-double slide-right">
            <img
              src="@/assets/pictures/livraison-programee-2.webp"
              alt="livreur effectuant une livraison planifiée sur chantier"
              class="img-fluid"
            />
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </section>
      <!--Section: Content-->
    </div>

    <!--Section: Content-->
    <section class="container my-5 pb-2">
      <!-- Grid row -->
      <div class="block-row reverse">
        <!-- Grid column -->
        <div class="block-text slide-right col-lg-5">
          <!-- Category -->
          <!-- Post title -->
          <TitleColor
            title="Des missions de livraison toute l’année"
            titleColor="#52c234"
            bgColor="#52c234"
          />
          <!-- Excerpt -->
          <p>
            Grâce à <span class="brand-name">Livratos</span>, vous ne dépendez
            plus seulement de quelques clients occasionnels : vous accédez à des
            <strong>missions de livraison</strong> toute l’année auprès de
            différents professionnels du BTP à {{ town.town }}. En tant que
            <strong>livreur</strong> ou
            <strong>chauffeur-livreur indépendant</strong>, vous choisissez vos
            créneaux, vos zones et le volume de travail que vous souhaitez
            accepter. Les matériaux sont chargés chez le fournisseur, puis
            <strong>livrés</strong> sur le <strong>chantier</strong> selon les
            demandes, ce qui vous permet de construire une activité régulière et
            d’optimiser vos journées sans perdre de temps à chercher de
            nouvelles missions.
          </p>
          <ArrowBtn
            href="/about"
            whiteCircleBackground="#52c234"
            circleBoxShadow="0 0 2px 2px #52c234"
          />
        </div>
        <!-- Grid column -->
        <!-- Grid column -->
        <div class="col-lg-6">
          <!-- Featured image -->
          <div class="view overlay rounded z-depth-2 mb-lg-0 slide-left">
            <img
              src="@/assets/pictures/livraison-express-2.webp"
              alt="livreur en mission de livraison express pour le BTP"
              class="img-fluid"
            />
          </div>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
    </section>
    <!--Section: Content-->
    <section class="container mt-lg-5">
      <div class="block-row pt-lg-2 pb-5 mb-5">
        <!-- Grid column -->
        <div class="block-text col-lg-5 slide-left">
          <!-- Featured image -->

          <!-- Section description -->
          <TitleColor
            title="Trouver des clients en tant que chauffeur-livreur indépendant"
            titleColor="#52c234"
            bgColor="#52c234"
          />
          <p class="text-left mx-auto w-responsive">
            Quand on est <strong>chauffeur-livreur indépendant</strong>, le plus
            difficile est souvent de trouver des clients réguliers sans passer
            ses journées à prospecter. Avec
            <span class="brand-name">Livratos</span>, les demandes des
            fournisseurs BTP de {{ town.town }} arrivent directement sur la
            plateforme sous forme de <strong>missions de livraison</strong>.
            Vous n’avez plus qu’à choisir les courses qui correspondent à votre
            véhicule, à vos horaires et à votre zone géographique. Cette
            organisation vous permet d’augmenter vos revenus, de diversifier vos
            clients et de sécuriser votre activité de
            <strong>livreur indépendant</strong> sur le long terme.
          </p>

          <ArrowBtn
            href="/about"
            whiteCircleBackground="#52c234"
            circleBoxShadow="0 0 2px 2px #52c234"
          />
        </div>
        <!-- Grid column -->

        <!-- Grid column -->
        <div class="col-12 col-lg-5 pt-lg-5 img-double slide-right">
          <img
            src="@/assets/pictures/livraison-express-1.webp"
            alt="tableau de bord de missions pour chauffeur-livreur indépendant"
            class="img-fluid"
          />
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
      <!-- Grid row -->
      <ContactUsAction />
      <!-- Grid row -->
    </section>
    <!--/DEVWEB-->
    <!--SEO/SEA-->
    <div class="container my-5">
      <!--Section: Content-->
      <section class="">
        <!-- Section heading -->

        <!-- Grid row -->
        <div class="container mb-lg-5">
          <h2
            id="referencement-google"
            class="text-center font-weight-bold mb-4"
          >
            Des missions de livraison adaptées à chaque type de chantier
          </h2>
          <p class="text-center mx-auto">
            Avec <span class="brand-name">Livratos</span>, chaque
            <strong>mission de livraison</strong> est adaptée au terrain :
            rénovation, gros œuvre, second œuvre, petits dépannages ou gros
            <strong>chantier</strong> de <strong>BTP</strong>. En tant que
            <strong>livreur indépendant</strong>, vous choisissez le type de
            matériel à transporter, la distance qui vous convient et le secteur
            autour de {{ town.town }} sur lequel vous souhaitez intervenir.
          </p>
        </div>
        <div class="block-row pt-5">
          <!-- Grid column -->
          <div class="block-text col-lg-5 slide-left">
            <!-- Featured image -->

            <!-- Section description -->
            <TitleColor
              title="Adapter chaque mission de livraison au terrain BTP"
              titleColor="#52c234"
            />
            <p class="text-left mx-auto w-responsive">
              Chaque <strong>chantier</strong> a ses particularités : accès
              étroits, horaires serrés, consignes de sécurité spécifiques. En
              tant que <strong>livreur</strong> sur {{ town.town }}, vous devez
              pouvoir adapter votre <strong>mission de livraison</strong> à ces
              contraintes. Grâce à <span class="brand-name">Livratos</span>,
              tous ces éléments sont précisés dès la publication de la mission :
              adresse, type de véhicule recommandé, créneaux possibles et
              contact sur place. Vous acceptez ainsi les
              <strong>missions de livraison</strong> en toute connaissance de
              cause et intervenez dans de bonnes conditions, ce qui améliore
              votre efficacité et la satisfaction de vos clients professionnels
              à {{ town.town }}.
            </p>

            <ArrowBtn
              href="/"
              whiteCircleBackground="#52c234"
              circleBoxShadow="0 0 2px 2px #52c234"
            />
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-12 col-lg-5 img-double slide-right">
            <img
              src="@/assets/pictures/login-mockup.webp"
              alt="interface présentant différentes missions de livraison BTP"
              class="img-fluid"
            />
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </section>
      <!--Section: Content-->
    </div>

    <!--Section: Content-->
    <section class="container my-5 pb-5">
      <!-- Grid row -->
      <div class="block-row reverse">
        <!-- Grid column -->
        <div class="block-text slide-right col-lg-5">
          <!-- Category -->
          <!-- Post title -->
          <TitleColor
            title="Suivre et contrôler vos missions de livraison en temps réel"
            titleColor="#52c234"
            bgColor="#52c234"
          />
          <!-- Excerpt -->
          <p class="text-left mx-auto w-responsive">
            Grâce à l’interface <span class="brand-name">Livratos</span>, vous
            suivez en temps réel chacune de vos
            <strong>missions de livraison</strong> à {{ town.town }} : mission
            acceptée, <strong>livraison</strong> en cours, course
            <strong>livrée</strong>, éventuels commentaires des clients ou
            remarques à propos du <strong>chantier</strong>. En tant que
            <strong>livreur indépendant</strong>, vous disposez d’une vision
            claire de votre activité, de vos revenus et de votre historique de
            livraisons, ce qui vous permet d’optimiser votre organisation et de
            professionnaliser encore davantage votre métier de
            <strong>chauffeur-livreur</strong>.
          </p>

          <ArrowBtn
            href="/"
            whiteCircleBackground="#52c234"
            circleBoxShadow="0 0 2px 2px #52c234"
          />
        </div>
        <!-- Grid column -->
        <!-- Grid column -->
        <div class="col-lg-6">
          <!-- Featured image -->
          <div class="view overlay rounded z-depth-2 mb-lg-0 slide-left">
            <img
              src="@/assets/pictures/visu-livratos-2.webp"
              alt="écran de suivi des missions de livraison pour livreur indépendant"
              class="spe-img img-fluid"
            />
          </div>
        </div>
        <!-- Grid column -->
      </div>
      <!-- Grid row -->
    </section>
    <!--Section: Content-->
    <ContactUsAction />
    <!--/SEASEO-->
    <!--MARKETING-->
    <div class="container mt-5">
      <!--Section: Content-->
      <section class="">
        <!-- Section heading -->

        <!-- Grid row -->
        <div class="container mb-lg-5 mt-5">
          <h2 id="marketing-digital" class="text-center font-weight-bold mb-4">
            {{ town.content }}<span class="span-ml"> :</span>
          </h2>
          <p class="text-center mx-auto mb-lg-5">
            <span class="brand-name">Livratos</span> est née de la rencontre
            entre des professionnels du <strong>BTP</strong> et des experts du
            digital. Ensemble, ils ont conçu une solution simple pour connecter
            <strong>fournisseurs BTP</strong>,
            <strong>livreurs indépendants</strong> et
            <strong>artisans</strong> autour d’une même promesse : des matériaux
            <strong>livrés</strong> au bon moment, sur le bon
            <strong>chantier</strong>. La plateforme devient ainsi un véritable
            outil pour développer son activité de <strong>livreur</strong> à
            {{ town.town }} en accédant à des
            <strong>missions de livraison</strong> claires, bien encadrées et
            adaptées au terrain.
          </p>
        </div>
        <div class="block-row pt-5">
          <!-- Grid column -->
          <div class="block-text col-lg-5 slide-left">
            <!-- Featured image -->

            <!-- Section description -->
            <TitleColor title="L'histoire de Livratos" titleColor="#52c234" />
            <p class="text-left mx-auto w-responsive">
              Pensée comme un « Uber » de la <strong>livraison</strong> pour le
              <strong>BTP</strong>, <span class="brand-name">Livratos</span> a
              été créée pour répondre à un constat simple : les
              <strong>artisans</strong> perdent des heures à aller chercher
              leurs matériaux et les <strong>fournisseurs BTP</strong> n’ont pas
              toujours les moyens d’assurer eux-mêmes la
              <strong>livraison sur chantier</strong>. En centralisant les
              demandes de <strong>livraison</strong> et en les confiant à des
              <strong>livreurs indépendants</strong>, la plateforme permet à
              chacun de se concentrer sur son métier : vendre pour le
              <strong>fournisseur BTP</strong>, produire pour
              l’<strong>artisan</strong>, <strong>livrer</strong> efficacement
              pour le <strong>livreur</strong>. Résultat : des matériaux mieux
              <strong>livrés</strong>, des <strong>chantiers</strong> plus
              fluides, et pour les
              <strong>chauffeurs-livreurs indépendants</strong>, une nouvelle
              façon de trouver des <strong>missions de livraison</strong> à
              {{ town.town }} sans passer par la prospection classique.
            </p>
            <ArrowBtn
              href="/"
              whiteCircleBackground="#52c234"
              circleBoxShadow="0 0 2px 2px #52c234"
            />
          </div>
          <!-- Grid column -->

          <!-- Grid column -->
          <div class="col-12 col-lg-5 img-double slide-right">
            <img
              src="@/assets/brand/logo-y.webp"
              alt="logo de la plateforme de missions de livraison BTP Livratos"
              class="img-fluid"
            />
          </div>
          <!-- Grid column -->
        </div>
        <!-- Grid row -->
      </section>
      <!--Section: Content-->
    </div>

    <!--Section: Content-->

    <!--Section: Content-->
    <!--/Marketing-->
    <div class="container service-contact image-fade-in">
      <CallActionService />
    </div>
  </main>
</template>

<script>
import { useMeta } from "vue-meta";
import { toRef, watchEffect } from "vue";
import TriangleSeparator from "@/components/partials/TriangleSeparator.vue";
import ArrowBtn from "@/components/partials/ArrowBtn.vue";
import TitleColor from "@/components/partials/TitleColor.vue";
import ContactUsAction from "@/components/partials/ContactUsAction.vue";
import CallActionService from "@/components/partials/CallActionService.vue";
import { mapGetters } from "vuex";
import { formatDate } from "@/assets/globalJs/global.js";

export default {
  components: {
    TriangleSeparator,
    ArrowBtn,
    TitleColor,
    ContactUsAction,
    CallActionService,
  },
  name: "CreationRead",
  props: {
    town: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const townProp = toRef(props, "town");

    watchEffect(() => {
      if (townProp.value) {
        const townName = townProp.value.town;

        const sentenceBegin =
          "Trouvez des missions de livraison pour livreur indépendant à " +
          townName +
          ". ";
        const sentenceEnd =
          " Rejoignez Livratos pour accéder à des missions de livraison BTP sur chantier et développer votre activité de chauffeur-livreur autour de " +
          townName +
          " et ses alentours.";

        const metaDescription =
          sentenceBegin + townProp.value.content + sentenceEnd;

        const townSlug = townName
          .normalize("NFD")
          .replace(/[\u0300-\u036f]/g, "")
          .toLowerCase()
          .replace(/\s+/g, "-")
          .replace(/[^a-z0-9-]/g, "");

        useMeta({
          title: "Missions pour livreur indépendant sur " + townName,
          description: [
            {
              content: metaDescription,
            },
          ],
          link: [
            {
              rel: "canonical",
              href: "https://www.livratos.fr/missions-livreurs/" + townSlug,
            },
          ],
        });
      }
    });

    return {
      townData: townProp,
    };
  },
  computed: {
    formattedDate() {
      return formatDate(this.town.updatedAt);
    },
    ...mapGetters({
      Towns: "StateTowns",
      User: "StateUser",
      TownDataFromStore: "StateTown",
    }),
  },
  methods: {
    scrollTo(sectionId) {
      const section = document.getElementById(sectionId);
      if (section) {
        window.scrollTo({
          top: section.offsetTop,
          behavior: "smooth",
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
// =========================
// Palette minimale Livratos
// =========================
$primary: $color-primary;
$black: #000;
$white: #fff;

// =========================
// Typo & utilitaires
// =========================
.service-header {
  margin-top: 72px;
}

p,
h2,
h3,
h4 {
  color: $color-darker;
}

.brand-name {
  color: $primary;
}

.span-ml {
  margin-left: 4px;
}

// =========================
// Header service
// =========================
.service-header {
  height: 50vh;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;

  background: #52c234; /* fallback for old browsers */
  background: -webkit-linear-gradient(
    to right,
    #061700,
    #52c234
  ); /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(
    to right,
    #061700,
    #52c234
  ); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */

  h1 {
    color: $white;
    font-size: 2em;
    text-align: center;
  }

  p {
    color: $color-lighter;
    font-size: 1.3em;
    text-align: center;

    .fake-space {
      margin-left: 8px;
    }
  }
}

// =========================
// Cartes génériques service
// =========================
.card-service:hover {
  @include grow;
}

.service-card {
  @include thumbnail;
  height: 100%;
  padding: 15px;

  .card-body {
    padding: 0;

    h4 {
      font-size: 1.3em;
      margin: 15px 5px 0;
      color: $color-text-grey;
    }
  }
}

// =========================
// Layout blocs texte / image
// =========================
.block-row {
  display: flex;
  flex-direction: column-reverse;
  justify-content: center;
  align-items: center;

  @media screen and (min-width: 992px) {
    flex-direction: row;
    justify-content: space-between;
    align-items: flex-start;
  }

  video,
  img {
    width: 500px;
    max-width: 90vw;
    margin-top: 30px;
    margin-bottom: 10px;

    @media screen and (min-width: 992px) {
      width: 500px;
      margin-top: 30px;
      margin-bottom: 0;
    }
  }
  .spe-img {
    max-width: 370px;
  }

  .img-double {
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .hr {
    width: 50px;
    height: 3px;
    background-color: $background;
  }
}

.reverse {
  flex-direction: column-reverse;

  @media screen and (min-width: 992px) {
    flex-direction: row-reverse !important;
  }
}

// =========================
// Section call-to-action
// =========================
.service-contact {
  margin-top: 100px;
  margin-bottom: 200px;

  @media screen and (min-width: 992px) {
    margin-top: 200px;
  }

  &__text {
    display: flex;
    flex-direction: column;
    justify-content: center;

    h3 {
      color: $color-lighter;
    }

    a {
      background: $bold-light-primary;
      width: fit-content;
      margin: auto;

      &:hover {
        background: $primary;
        border-color: $color-text;
      }
    }
  }
}

// =========================
// Traits colorés (blocs)
// Tout passe sur la même logique vert Livratos
// =========================
.cyan,
.purple,
.orange,
.yellow {
  border-top: 1.5px solid $primary;
}

// =========================
// Effet "encre" (si utilisé)
// =========================
.ink {
  width: 200px;
  height: 200px;
  background-color: $black;
  border-radius: 50%;
  position: relative;

  &::before,
  &::after {
    content: "";
    position: absolute;
    width: 100px;
    height: 150px;
    background-color: $black;
    border-radius: 50%;
    transform: rotate(45deg);
  }

  &::before {
    top: -30px;
    left: 50px;
  }

  &::after {
    bottom: -60px;
    right: 50px;
  }
}

// =========================
// Features (3 boxes Livratos)
// =========================
.features {
  .container {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-wrap: wrap;
    padding: 40px 0;
  }

  .container-title {
    font-size: 35px;
    font-weight: bold;
    margin-bottom: 40px;
    color: $color-lighter;
    text-align: center;

    @media (min-width: 992px) {
      font-size: 51px;
      margin-bottom: 80px;
    }
  }

  .container .box {
    position: relative;
    width: 320px;
    height: 500px;
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 40px 30px;
    transition: 0.5s;
  }

  // Fond "skew" – neutre (blanc) animé
  .container .box::before {
    content: "";
    position: absolute;
    top: 0;
    left: 50px;
    width: 50%;
    height: 100%;
    background: $white;
    border-radius: 8px;
    transform: skewX(15deg);
    transition: 0.5s;
  }

  .container .box::after {
    content: "";
    position: absolute;
    top: 0;
    left: 50px;
    width: 50%;
    height: 100%;
    background: $white;
    border-radius: 8px;
    transform: skewX(15deg);
    transition: 0.5s;
    filter: blur(30px);
  }

  .container .box:hover::before,
  .container .box:hover::after {
    transform: skewX(0deg);
    left: 20px;
    width: calc(100% - 90px);
  }

  // Variation subtile par carte : juste l'opacité du vert/ noir
  .container .box:nth-child(1)::before,
  .container .box:nth-child(1)::after {
    background: linear-gradient(315deg, #52c234, $primary);
  }

  .container .box:nth-child(2)::before,
  .container .box:nth-child(2)::after {
    background: linear-gradient(315deg, $primary, #52c234);
  }

  .container .box:nth-child(3)::before,
  .container .box:nth-child(3)::after {
    background: linear-gradient(315deg, #52c234, $primary);
  }

  // Effets vitre / glow
  .container .box span {
    display: block;
    position: absolute;
    inset: 0;
    z-index: 5;
    pointer-events: none;
  }

  .container .box span::before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 0;
    height: 0;
    border-radius: 8px;
    background: rgba($white, 0.1);
    backdrop-filter: blur(10px);
    opacity: 0;
    transition: 0.1s;
    animation: animate 2s ease-in-out infinite;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  }

  .container .box:hover span::before {
    top: -50px;
    left: 50px;
    width: 100px;
    height: 100px;
    opacity: 1;
  }

  .container .box span::after {
    content: "";
    position: absolute;
    bottom: 0;
    right: 0;
    width: 100%;
    height: 100%;
    border-radius: 8px;
    background: rgba($white, 0.1);
    backdrop-filter: blur(10px);
    opacity: 0;
    transition: 0.5s;
    animation: animate 2s ease-in-out infinite;
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
    animation-delay: -1s;
  }

  .container .box:hover span::after {
    bottom: -50px;
    right: 50px;
    width: 100px;
    height: 100px;
    opacity: 1;
  }

  @keyframes animate {
    0%,
    100% {
      transform: translateY(10px);
    }

    50% {
      transform: translate(-10px);
    }
  }

  // Contenu des cartes
  .container .box .content {
    position: relative;
    left: 0;
    padding: 20px 40px;
    background: rgba($black, 0.9);
    backdrop-filter: blur(10px);
    box-shadow: 0 5px 15px rgba(0, 0, 0, 0.1);
    border-radius: 8px;
    z-index: 1;
    color: $white;
    transition: 0.5s;
    height: 90%;
  }

  .container .box:hover .content {
    left: -25px;
    padding: 60px 40px;
  }

  .container .box .content h2 {
    font-size: 2em;
    color: $color-primary;
    margin-bottom: 10px;
  }

  .container .box .content p {
    font-size: 1.1em;
    margin-bottom: 10px;
    line-height: 1.4em;
    color: $white;
  }

  .container .box .content a {
    display: inline-block;
    font-size: 1.1em;
    color: $black;
    background: $white;
    padding: 10px;
    border-radius: 4px;
    text-decoration: none;
    font-weight: 700;
    margin-top: 5px;
    border: 1px solid transparent;
  }

  .container .box .content a:hover {
    background: $primary;
    color: $white;
    border: 1px solid rgba(0, 0, 0, 0.2);
    box-shadow: 0 1px 15px rgba(1, 1, 1, 0.2);
  }
}
</style>
